import { ProductOut } from '../../../store/api';
import React, { useContext } from 'react';
import { SelectionContext } from '../context/SelectionContext';
import classNames from 'classnames';

export const SelectProductButton = ({ product }: { product: ProductOut }) => {
    const { selection, selectSingleProduct, isInSelectionMode, isSelectAll } = useContext(SelectionContext);
    const selected = selection.includes(product.id!);

    const classes = classNames('icn-select', {
        selected,
        'selection-mode': isInSelectionMode || isSelectAll
    });

    const title = `${selected ? 'de' : ''}select product`;
    return (
        <i
            data-testid="select-button"
            className={classes}
            title={title}
            onClick={() => {
                selectSingleProduct(product.id!);
            }}
        />
    );
};
